import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Building } from 'brain-data/model/building.model';

export interface CreateOrUpdateBuildingDTO {
  id?: number;
  name: string;
  latitude: number;
  longitude: number;
  yearBuilt?: number;
  grossArea?: number;
  vacant?: boolean;
}

export interface CreateOrUpdateBuildingsRequest {
  buildings: CreateOrUpdateBuildingDTO[];
}

@Injectable({ providedIn: 'root' })
export class BuildingService {
  private readonly baseUrl = `${environment.apiBaseUrl}`;

  constructor(private http: HttpClient) {}

  addBuildings(facilityId: number, buildings: CreateOrUpdateBuildingDTO[]): Observable<Building[]> {
    const payload: CreateOrUpdateBuildingsRequest = { buildings };
    return this.http.post<Building[]>(`${this.baseUrl}/facilities/${facilityId}/buildings`, payload);
  }

  updateBuildings(facilityId: number, buildings: CreateOrUpdateBuildingDTO[]): Observable<Building[]> {
    const payload: CreateOrUpdateBuildingsRequest = { buildings };
    return this.http.put<Building[]>(`${this.baseUrl}/facilities/${facilityId}/buildings`, payload);
  }

  deleteBuildings(facilityId: number, ids: number[]): Observable<void> {
    const params = new URLSearchParams();
    ids.forEach(id => params.append('ids', id.toString()));
    return this.http.delete<void>(`${this.baseUrl}/facilities/${facilityId}/buildings?${params.toString()}`);
  }
}
